import { External } from '../external';

const BASE_URL = `https://${External.serviceApiDomain}/comment/admin`;

export class HttpError extends Error {
  constructor(message, statusCode, response) {
    super(message);
    this.name = 'HttpError';
    this.statusCode = statusCode;
    this.response = response;
  }
}

const CommentAdminService = {
  getContext: async (resourceType, resourceId) => {
    const url = `${BASE_URL}/context/${resourceType}/${resourceId}`;
    const response = await fetch(url, {
      method: 'GET',
      cache: 'no-cache',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'X-Website-Hash': External.WebPlatform.hash,
        'X-Admin-Hash': External.Website.hash
      }
    });

    if (!response.ok) {
      const errorResponse = await response.text().catch(() => '');
      throw new HttpError(`Service Error ${response.status}: ${errorResponse}`, response.status, errorResponse);
    }

    return await response.json();
  },
  createContext: async (context) => {
    const url = `${BASE_URL}/context`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Website-Hash': External.WebPlatform.hash,
        'X-Admin-Hash': External.Website.hash
      },
      body: JSON.stringify(context)
    });
    return await response.json();
  },
  partialUpdateContext: async (resourceType, resourceId, partialUpdate) => {
    const url = `${BASE_URL}/context`;
    const response = await fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-Website-Hash': External.WebPlatform.hash,
        'X-Admin-Hash': External.Website.hash
      },
      body: JSON.stringify({
        resourceType: resourceType,
        resourceId: resourceId,
        ...partialUpdate
      })
    });
    return await response.json();
  },
  getMemberDetails: async (memberId) => {
    const url = `${BASE_URL}/member/${memberId}`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Website-Hash': External.WebPlatform.hash,
        'X-Admin-Hash': External.Website.hash
      }
    });
    return await response.json();
  },
  makeAdmin: async (memberId, groupId) => {
    if (!groupId) {
      groupId = 'default';
    }
    const url = `${BASE_URL}/make-admin/${memberId}/${groupId}`;
    return await fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-Website-Hash': External.WebPlatform.hash,
        'X-Admin-Hash': External.Website.hash
      }
    });
  },
  makeModerator: async (memberId, groupId) => {
    if (!groupId) {
      groupId = 'default';
    }
    const url = `${BASE_URL}/make-moderator/${memberId}/${groupId}`;
    return await fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-Website-Hash': External.WebPlatform.hash,
        'X-Admin-Hash': External.Website.hash
      }
    });
  },
  makeOrdinaryMember: async (memberId, groupId) => {
    if (!groupId) {
      groupId = 'default';
    }
    const url = `${BASE_URL}/make-member/${memberId}/${groupId}`;
    return await fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-Website-Hash': External.WebPlatform.hash,
        'X-Admin-Hash': External.Website.hash
      }
    });
  },
  muteMember: async (memberId, groupId) => {
    if (!groupId) {
      groupId = 'default';
    }
    const url = `${BASE_URL}/mute/${memberId}/${groupId}`;
    return await fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-Website-Hash': External.WebPlatform.hash,
        'X-Admin-Hash': External.Website.hash
      }
    });
  },
  unmuteMember: async (memberId, groupId) => {
    if (!groupId) {
      groupId = 'default';
    }
    const url = `${BASE_URL}/unmute/${memberId}/${groupId}`;
    return await fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-Website-Hash': External.WebPlatform.hash,
        'X-Admin-Hash': External.Website.hash
      }
    });
  },
  getMutedMembers: async (groupId, query, page, limit) => {
    if (!groupId) {
      groupId = 'default';
    }

    const params = new URLSearchParams();
    params.append('r', "2147483647"); // max int 32 for muted
    if (query && query.trim().length > 0) {
      params.append('q', query.trim());
    }
    params.append('page', page);
    params.append('limit', limit);

    const url = `${BASE_URL}/group/${groupId}/members?${params.toString()}`;
    return (await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Website-Hash': External.WebPlatform.hash,
        'X-Admin-Hash': External.Website.hash
      }
    })).json();
  }
};
export default CommentAdminService;
